import React, { FC } from "react";

import { Skeleton, Box, Grid, Card, CardContent } from "@components/base";

const CollectDataSkeleton: FC = () => (
  <Card>
    <CardContent>
      <Box pt={3}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <Skeleton variant="rounded" height={30} />
          </Grid>
          <Grid size={12}>
            <Skeleton variant="rounded" height={300} />
          </Grid>
        </Grid>
      </Box>
    </CardContent>
  </Card>
);

export default CollectDataSkeleton;
